"use strict";

import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
import React, { createContext, useCallback, useContext, useLayoutEffect, useRef, useState } from "react";
import { assignInlineVars } from "@vanilla-extract/dynamic";
import { randomString } from "../../../utils";
import { Label } from "../Label";
import { Text } from "../Text";
import Tooltip from "../Tooltip/Tooltip";
import classNames from "classnames";
import { Expandable } from "../../behaviors/Expandable";
import { duration } from "../../../tokens/tokens-css";
import { IconSize, Warning } from "../../icons";
import { Separator } from "../Separator/Separator";
import * as styles from "./SegmentedControl-css";
var SegmentedControlContext = createContext({});
var labelSize = /* @__PURE__ */new Map([["xs", "s"], ["s", "m"], ["m", "m"], ["l", "m"]]);
export var SegmentedControl = function SegmentedControl(_a) {
  var _assignInlineVars;
  var _b = _a,
    children = _b.children,
    value = _b.value,
    onChange = _b.onChange,
    label = _b.label,
    labelHidden = _b.labelHidden,
    _b$size = _b.size,
    size = _b$size === void 0 ? "m" : _b$size,
    error = _b.error,
    className = _b.className,
    _b$asymmetric = _b.asymmetric,
    asymmetric = _b$asymmetric === void 0 ? false : _b$asymmetric,
    props = __objRest(_b, ["children", "value", "onChange", "label", "labelHidden", "size", "error", "className", "asymmetric"]);
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    indicator = _useState2[0],
    setIndicator = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    transitioning = _useState4[0],
    setTransitioning = _useState4[1];
  var id = useRef("segmented-".concat(randomString()));
  var labelId = "".concat(id.current, "-label");
  var errorId = "".concat(id.current, "-error");
  var optionRefs = useRef([]);
  var indicatorRef = useRef(null);
  var optionsRef = useRef(null);
  var currentOption = useRef();
  var handleKeyDown = function handleKeyDown(event) {
    var _a2, _b2;
    var options = optionRefs.current.filter(function (option) {
      var _a3;
      return !((_a3 = option.element.current) == null ? void 0 : _a3.disabled);
    });
    var currentIndex = options.indexOf(options.find(function (option) {
      return option.value === value;
    }) || options[0]);
    var length = options.length;
    var prevIndex = (currentIndex - 1 + length) % length;
    var nextIndex = (currentIndex + 1) % length;
    var prevOption = options[prevIndex];
    var nextOption = options[nextIndex];
    if (["ArrowLeft", "ArrowUp"].includes(event.key)) {
      onChange(prevOption.value);
      (_a2 = prevOption.element.current) == null ? void 0 : _a2.focus();
    } else if (["ArrowRight", "ArrowDown"].includes(event.key)) {
      onChange(nextOption.value);
      (_b2 = nextOption.element.current) == null ? void 0 : _b2.focus();
    }
  };
  var registerOption = useCallback(function (optionRef, optionValue) {
    if (optionValue === value) {
      currentOption.current = optionRef.current;
    }
    optionRefs.current = [].concat(_toConsumableArray(optionRefs.current), [{
      element: optionRef,
      value: optionValue
    }]);
  }, [value]);
  var unregisterOption = useCallback(function (optionRef) {
    optionRefs.current = optionRefs.current.filter(function (ref) {
      return ref.element !== optionRef;
    });
  }, []);
  var updateIndicator = function updateIndicator() {
    var _a2, _b2;
    var containerRect = (_a2 = optionsRef.current) == null ? void 0 : _a2.getBoundingClientRect();
    var currentOptionRect = (_b2 = currentOption.current) == null ? void 0 : _b2.getBoundingClientRect();
    if (!containerRect || !currentOptionRect) return;
    setIndicator({
      x: currentOptionRect.x - containerRect.x,
      width: currentOptionRect.width
    });
  };
  useLayoutEffect(function () {
    if (!currentOption.current) return;
    var resizeObserver = new ResizeObserver(updateIndicator);
    resizeObserver.observe(currentOption.current);
    updateIndicator();
    return function () {
      resizeObserver.disconnect();
    };
  }, []);
  useLayoutEffect(function () {
    var _a2;
    setTransitioning(true);
    currentOption.current = (_a2 = optionRefs.current.find(function (item) {
      return item.value === value;
    })) == null ? void 0 : _a2.element.current;
    updateIndicator();
  }, [value]);
  return /* @__PURE__ */React.createElement(SegmentedControlContext.Provider, {
    value: {
      optionRefs: optionRefs,
      currentValue: value,
      onChange: onChange,
      registerOption: registerOption,
      unregisterOption: unregisterOption,
      size: size
    }
  }, /* @__PURE__ */React.createElement("div", __spreadValues({
    className: classNames(styles.container, className),
    role: "radiogroup",
    tabIndex: 0,
    "aria-labelledby": labelId,
    onKeyDown: handleKeyDown,
    "aria-invalid": !!error,
    "aria-describedby": !!error ? errorId : void 0
  }, props), /* @__PURE__ */React.createElement(Label, {
    long: true,
    element: "label",
    hidden: labelHidden,
    id: labelId,
    size: labelSize.get(size) || "m"
  }, label), /* @__PURE__ */React.createElement("div", {
    className: styles.options({
      size: size,
      asymmetric: asymmetric
    }),
    ref: optionsRef
  }, !!indicator && /* @__PURE__ */React.createElement("div", {
    ref: indicatorRef,
    className: styles.indicator({
      transitioning: transitioning
    }),
    onTransitionEnd: function onTransitionEnd() {
      return setTransitioning(false);
    },
    style: assignInlineVars((_assignInlineVars = {}, _defineProperty(_assignInlineVars, styles.indicatorLeft, "".concat(indicator.x, "px")), _defineProperty(_assignInlineVars, styles.indicatorWidth, "".concat(indicator.width, "px")), _assignInlineVars))
  }), children), /* @__PURE__ */React.createElement(Expandable, {
    expanded: !!error,
    timeout: duration.s
  }, function (_ref) {
    var expandableElementRef = _ref.expandableElementRef;
    return /* @__PURE__ */React.createElement("div", {
      id: errorId,
      className: styles.error,
      ref: expandableElementRef,
      "aria-live": "polite"
    }, /* @__PURE__ */React.createElement("div", {
      className: styles.errorIcon
    }, /* @__PURE__ */React.createElement(Warning, {
      size: IconSize.Small,
      color: "critical"
    })), /* @__PURE__ */React.createElement(Text, {
      lineHeight: "compact",
      size: "s"
    }, error));
  })));
};
var optionTextSize = /* @__PURE__ */new Map([["xs", "xs"], ["s", "s"], ["m", "s"], ["l", "m"]]);
export var SegmentedControlOption = function SegmentedControlOption(_c) {
  var _d = _c,
    value = _d.value,
    icon = _d.icon,
    startElement = _d.startElement,
    endElement = _d.endElement,
    labelHidden = _d.labelHidden,
    label = _d.label,
    disabled = _d.disabled,
    tooltip = _d.tooltip,
    className = _d.className,
    props = __objRest(_d, ["value", "icon", "startElement", "endElement", "labelHidden", "label", "disabled", "tooltip", "className"]);
  var _a, _b, _c2;
  var _useContext = useContext(SegmentedControlContext),
    optionRefs = _useContext.optionRefs,
    currentValue = _useContext.currentValue,
    onChange = _useContext.onChange,
    registerOption = _useContext.registerOption,
    unregisterOption = _useContext.unregisterOption,
    size = _useContext.size;
  var optionRef = useRef(null);
  var isSelected = currentValue === value;
  var currentIndex = (_a = optionRefs == null ? void 0 : optionRefs.current) == null ? void 0 : _a.indexOf(optionRefs.current.find(function (option) {
    return option.value === value;
  }) || optionRefs.current[0]);
  var selectedIndex = ((_b = optionRefs == null ? void 0 : optionRefs.current) == null ? void 0 : _b.indexOf(optionRefs.current.find(function (option) {
    return option.value === currentValue;
  }) || optionRefs.current[0])) || 0;
  var isLast = currentIndex === (((_c2 = optionRefs.current) == null ? void 0 : _c2.length) || 0) - 1;
  var hasSeparator = !isSelected && currentIndex !== selectedIndex - 1 && !isLast;
  useLayoutEffect(function () {
    registerOption(optionRef, value);
    return function () {
      unregisterOption(optionRef, value);
    };
  }, [registerOption, unregisterOption, value]);
  var renderButton = function renderButton() {
    return /* @__PURE__ */React.createElement("button", __spreadValues({
      className: classNames(styles.button({
        separator: hasSeparator
      }), className),
      tabIndex: isSelected ? 0 : -1,
      role: "radio",
      type: "button",
      "aria-checked": isSelected,
      "aria-label": labelHidden && typeof label === "string" ? label : void 0,
      onClick: function onClick() {
        return onChange(value);
      },
      ref: optionRef,
      disabled: disabled
    }, props), !!startElement && /* @__PURE__ */React.createElement("div", {
      className: styles.element
    }, startElement), !!icon && /* @__PURE__ */React.createElement("div", {
      className: styles.element
    }, icon), !labelHidden && /* @__PURE__ */React.createElement(Text, {
      className: styles.text,
      strong: true,
      truncate: true,
      size: optionTextSize.get(size) || "s",
      hidden: labelHidden
    }, label), !!endElement && /* @__PURE__ */React.createElement("div", {
      className: styles.element
    }, endElement), /* @__PURE__ */React.createElement(Separator, {
      direction: "vertical",
      size: "65%",
      className: styles.separator({
        visible: hasSeparator
      })
    }));
  };
  if (!!tooltip) {
    return /* @__PURE__ */React.createElement(Tooltip, __spreadValues({}, tooltip), renderButton());
  }
  return renderButton();
};